import axios from "axios";
import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';

// 1. Import vue-toastification & CSS
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// 2. Import Socket.IO client
import { io } from "socket.io-client";

// 3. Leaflet Setup
import { Icon } from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import 'leaflet/dist/leaflet.css';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// 4. Setup Toast Options
const toastOptions = {
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
};

Vue.use(Toast, toastOptions);
Vue.config.productionTip = false;

// 5. Setup Axios Base URL
const xhost = process.env.VUE_APP_API_URL;
// Pastikan ENV VUE_APP_API_URL diisi, atau tambahkan fallback string jika kosong
// e.g: const xhost = process.env.VUE_APP_API_URL || 'http://localhost:8084/spju';

axios.defaults.baseURL = (xhost + "/").replace(/\/+$/, "/"); // Menambahkan slash di akhir
axios.defaults.withCredentials = true; // PENTING: Untuk cookie/session

// Axios Interceptor (Attach Token to every HTTP Request)
axios.interceptors.request.use(function (config) {
  let token = store.getters.USER_INFO?.token;

  if (!token) {
    token = localStorage.getItem("token");
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}, function (error) {
  return Promise.reject(error);
});

Vue.prototype.$axios = axios;

// --- PERBAIKAN: Deklarasikan socket di luar agar bisa diekspor ---
let socket = null;

// 6. Initialize Vue Instance
const app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');

// --- INTEGRASI WEBSOCKET (Socket.io) ---
// Logika ini berjalan saat halaman direfresh/diload
const vUserInfo = store.getters.USER_INFO;

if (vUserInfo && vUserInfo.token) {
  // Gunakan URL dari ENV atau default ke localhost:4000 (Hapus trailing slash agar WS tidak error)
  const socketUrl = (process.env.VUE_APP_WEBSOCKET_URL || "http://localhost:4000").replace(/\/+$/, "");
  console.log("🔌 [WS-INIT] Connecting to:", socketUrl);

  socket = io(socketUrl, {
    withCredentials: true, // WAJIB: Sinkron dengan backend cors credentials: true
    auth: {
      token: vUserInfo.token // WAJIB: Sinkron dengan backend middleware auth
    }
  });

  socket.on("connect", () => {
    console.log("✅ WebSocket Connected ID:", socket.id);
    // Jika backend butuh register manual, uncomment baris bawah:
    // socket.emit('register', { deviceid: 'ID_DEVICE' }); 
  });

  socket.on("connect_error", (err) => {
    console.error("❌ WebSocket Connection Error:", err.message);
  });

  socket.on("disconnect", (reason) => {
    console.warn("⚠️ WebSocket Disconnected:", reason);
  });

  // Menerima event 'notification' dari server
  socket.on("notification", (notificationData) => {
    console.log("🔔 New notification received:", notificationData);

    // 1. Simpan ke Vuex Store (untuk history/bell dropdown legacy jika masih pakai)
    try {
      store.dispatch("notifications/addNotification", notificationData);
      // PERBAIKAN: Refresh alert summary agar bell icon count & dropdown terupdate otomatis
      store.dispatch("devices/fetchUnreadAlerts");
    } catch (err) {
      console.error("Vuex dispatch error:", err);
    }

    // 2. Tampilkan Toast Popup
    app.$toast.info(`Notifikasi: ${notificationData.message || 'Ada alert baru!'}`);
  });
} else {
  console.log("ℹ️ WebSocket skipped: No user token found (Login required)");
}

// --- PERBAIKAN: Ekspor instance socket ---
export { socket };

